import settings from '../devices/all/settings';

class LayersControl {

  static UXReference = null;
  static playerReference=null;
  static lastFocus=null;
  static getFocus(){
    const modal = document.getElementsByClassName('modal-overlay');
    if(modal.length===0){
      const elementoPredeterminadoFocus=window.SpatialNavigation.focus('.elementopredeterminado');
      if(!elementoPredeterminadoFocus){
        const ribbonFocus=window.SpatialNavigation.focus('.scroller-container .focusable');
        if(!ribbonFocus){
          window.SpatialNavigation.focus('.focusable');
        }
      }
    }

  }

  static moveHeader = () =>{
    const className = 'is-large';
    if(document && typeof  document.querySelector === 'function'){
      const navbarContainer = document.querySelector(".nav-container.down");
      if(navbarContainer && navbarContainer.clientWidth){
        const navbarSize = navbarContainer.clientWidth;
        if(navbarContainer &&  navbarContainer.classList){
          if(typeof navbarContainer.classList.contains === 'function' && navbarContainer.classList.contains(className) === false){ 
            if(typeof navbarContainer.classList.add === 'function' && navbarSize > 900){
              navbarContainer.classList.add(className);
            }
          }
        }
      }
    }
  }


  static showUX(hideUX=true)
  {
    if(!LayersControl.isUXVisible())
    {
      LayersControl.setVisible(LayersControl.UXReference);
      LayersControl.centerAAFMenu();
      setTimeout(this.getFocus,300);
      LayersControl.moveHeader();
    }
    if(LayersControl.isPlayerVisible() && hideUX)
    {
      LayersControl.setHidden(LayersControl.playerReference);
    }
  }
  static showPlayer(hideUX=true)
  {
    if(!LayersControl.isPlayerVisible())
    {
      LayersControl.setVisible(LayersControl.playerReference);
    }
    if(LayersControl.isUXVisible() && hideUX)
    {
      LayersControl.setHidden(LayersControl.UXReference);
    }
  }
  static hideUX(showPlayer=true)
  {
    if(LayersControl.isUXVisible())
    {
      LayersControl.setHidden(LayersControl.UXReference);
    }
    if(!LayersControl.isPlayerVisible() && showPlayer)
    {
      LayersControl.setVisible(LayersControl.playerReference);
    }

  }
  static hidePlayer(showUX=true)
  {
    if(LayersControl.isPlayerVisible())
    {
      LayersControl.setHidden(LayersControl.playerReference);

    }
    if(!LayersControl.isUXVisible() && showUX)
    {
      LayersControl.setVisible(LayersControl.UXReference);
    }
  }

  static isUXVisible(showPlayer=true)
  {
    LayersControl.getReferences();
    return LayersControl.checkVisibility(LayersControl.UXReference);
  }

  static isPlayerVisible(showPlayer=true)
  {
    LayersControl.getReferences();
    let re=LayersControl.checkVisibility(LayersControl.playerReference);
    return re;
  }
  static checkVisibility(element=null){
    if(element && element.style)
    {

      switch(element.style.display)
      {
        case "none":
          return false;
        case "":
        case "block":
        default:
          return true;
      }
    }
    else
      return false;
  }

  static setVisible(element=null){
    if(element && element.style) {
      element.style.display = "block";
    }
  }

  static setHidden(element=null){
    if(element && element.style) {
      element.style.display ="none";
      element.style.top=settings.full_player_position_top;
      element.style.left=settings.full_player_position_left;
      element.style.width=settings.full_player_position_width;
      element.style.height=settings.full_player_position_height;
    }
  }
  static getReferences(){
    if(LayersControl.UXReference == null) {
      LayersControl.UXReference = document.getElementById("uxMain");
    }
    if(LayersControl.playerReference == null) {
      LayersControl.playerReference = document.getElementById("playerMain");
    }
  }
  static goTo(destination=null, extradata={})
  {
    LayersControl.showUX();
    //window.location=
    if(destination) {
      console.log('TODO GO TO', destination, extradata);
    }
  }

  static centerAAFMenu() {
    let mainDiv, leftDiv, centerDiv, rightDiv , centerDivWidth = null;
    const IdHeader = document.getElementById('header');
    if(IdHeader) {
      const _mainDiv = document.getElementsByClassName('aaf_menu-container-main');
      const __mainDiv = Array.from(_mainDiv);
      mainDiv = __mainDiv[0];

      const _leftDiv = mainDiv.getElementsByClassName('aaf_menu-container-left');
      const __leftDiv = Array.from(_leftDiv);
      leftDiv = __leftDiv[0];

      const _centerDiv = mainDiv.getElementsByClassName('aaf_menu-container-center');
      const __centerDiv = Array.from(_centerDiv);
      centerDiv = __centerDiv[0];

      const _rightDiv = mainDiv.getElementsByClassName('aaf_menu-container-right');
      const __rightDiv = Array.from(_rightDiv);
      rightDiv = __rightDiv[0];

      centerDivWidth = centerDiv.offsetWidth > 750 ? 800 : centerDiv.offsetWidth;
    } 

    if (mainDiv && leftDiv && centerDiv && rightDiv) {
      const calcMarginLeft = (mainDiv.clientWidth - (leftDiv.offsetWidth + centerDivWidth + rightDiv.offsetWidth))/2;
      leftDiv.style.marginLeft = `${calcMarginLeft}px`;
    }
  }
}

export default LayersControl;



// WEBPACK FOOTER //
// ./src/utils/LayersControl.js